import { makeSelectors } from '@utils/css';

const crossFadeDurationMs = 200;
const checkmarkTransitionDurationMs = 150;
const modifiers = makeSelectors({
  async: "_araai0j0fx"
});
const circle = "_arac1we0ymo";
const button = "_arabipwq3r";
const icon = "_araipgeo8k";
const asyncProgressCircle = "_araa5dx77n";
const checkmark = "_arac1p4a5yt";
const label = "_aralzluln4";
const labelContent = "_aralhtypq9";

export { asyncProgressCircle, button, checkmark, checkmarkTransitionDurationMs, circle, crossFadeDurationMs, icon, label, labelContent, modifiers };
import "./atom.modal-button.style.linaria.module.css";
//# sourceMappingURL=atom.modal-button.style.js.map
